import DiscordIcon from '@/components/icons/logos/discord'
import FacebookIcon from '@/components/icons/logos/facebook'
import InstagramIcon from '@/components/icons/logos/instagram'
import RedditIcon from '@/components/icons/logos/reddit'
import SGPIcon from '@/components/icons/logos/sgp'
import SteamIcon from '@/components/icons/logos/steam'
import TwitterIcon from '@/components/icons/logos/twitter'
import YoutubeIcon from '@/components/icons/logos/youtube'
import PsIcon from '@/components/icons/platforms/ps'
import XboxIcon from '@/components/icons/platforms/xbox-one'

const SERVICE_DETAILS = {
  discord: {
    name: 'Discord',
    urlRoot: 'https://discord.gg/',
    Icon: DiscordIcon,
  },
  'discord-server': {
    name: 'Discord Server',
    urlRoot: 'https://discord.com/servers/',
    Icon: DiscordIcon,
  },
  'discord-user': {
    name: 'Discord',
    urlRoot: 'https://discord.com/users/',
    Icon: DiscordIcon,
  },
  facebook: {
    name: 'Facebook',
    urlRoot: 'https://www.facebook.com/',
    Icon: FacebookIcon,
  },
  'facebook-gaming': {
    name: 'Facebook Gaming',
    urlRoot: 'https://www.facebook.com/gaming/',
    Icon: FacebookIcon,
  },
  instagram: {
    name: 'Instagram',
    urlRoot: 'https://www.instagram.com/',
    Icon: InstagramIcon,
  },
  psn: {
    name: 'PlayStation Network',
    urlRoot: 'https://psnprofiles.com/',
    Icon: PsIcon,
  },
  reddit: {
    name: 'Reddit',
    urlRoot: 'https://www.reddit.com/user/',
    Icon: RedditIcon,
  },
  sgp: {
    name: 'SimRacing.gp',
    urlRoot: 'https://steamcommunity.com/groups/',
    Icon: SGPIcon,
  },
  steam: {
    name: 'Steam',
    urlRoot: 'https://steamcommunity.com/id/',
    Icon: SteamIcon,
  },
  twitter: { name: 'X', urlRoot: `https://x.com/`, Icon: TwitterIcon },
  'xbox-live': {
    name: 'Xbox Live',
    urlRoot: `http://live.xbox.com/Profile?Gamertag=`,
    Icon: XboxIcon,
  },
  youtube: {
    name: 'YouTube',
    urlRoot: 'https://youtube.com',
    Icon: YoutubeIcon,
  },
  website: { name: 'Website' },
}

export const getInviteServiceDetails = (serviceId) => {
  return SERVICE_DETAILS[serviceId]
}
